import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, IconButton, Avatar, Box } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  addCardButton: {
    cursor: 'pointer',
    display: 'block',
    alignItems: 'center',
    padding: 15,
    letterSpacing: 1,
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    border: 'none',
    borderRadius: 10,
    transition: '0.3s',
    boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)',
    backgroundColor: '#F78181',
    color: 'white',
    '&:hover': {
      backgroundColor: '#fa9898'
    },
    '&:active': {
      backgroundColor: '#F78181'
    },
    '@media (max-width:768px)': {
      width: '100%'
    }
  }
}));

export const Button = ({ handleClick, txtBtn, widthBtn }) => {
  const classes = useStyles();
  return (
    <button className={classes.addCardButton} onClick={handleClick} style={{ width: widthBtn }}>
      {txtBtn}
    </button>
  );
};
